export default "__VITE_ASSET__Bv3xE1gS__"